import { IconSize } from 'assets/icons/icon-sizes';
import ScheduleIcon from 'assets/icons/navigation/ScheduleIcon';
import { FlexCol, BodyLarge, FlexAlignCenter } from 'components/Elements';
import useWindowWidth from 'hooks/useWindowWidth';
import { LearnerCardBase } from 'pages/learner/sharedStyles/LearnerStyles';
import styled from 'styled-components';
import { sizes, breakpoints, FONTSIZE } from 'theme';
import strings from '../../strings/strings.json';

type DateCardProps = {
    startDate: Date;
    endDate?: Date;
};

export default function DateCard({ startDate, endDate }: DateCardProps) {
    const { isMobileWidth } = useWindowWidth();

    const formattedStartDate = new Date(startDate).toLocaleDateString('en-UK', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });

    let formattedEndDate;

    if (endDate) {
        endDate = new Date(endDate);
        formattedEndDate = endDate.toLocaleDateString('en-UK', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });
    }

    return (
        <DateContainerCard>
            <DateAndIconContainer>
                <ScheduleIcon size={isMobileWidth ? IconSize.LARGE : IconSize.XLARGE} />
                <FlexCol>
                    <BodyLarge>{strings.publicCoursePage.startDate}</BodyLarge>
                    <LargeDateText $bold>{formattedStartDate}</LargeDateText>
                </FlexCol>
            </DateAndIconContainer>
            {endDate && (
                <DateAndIconContainer>
                    <ScheduleIcon size={isMobileWidth ? IconSize.LARGE : IconSize.XLARGE} />
                    <FlexCol>
                        <BodyLarge>{strings.publicCoursePage.endDate}</BodyLarge>
                        <LargeDateText $bold>{formattedEndDate}</LargeDateText>
                    </FlexCol>
                </DateAndIconContainer>
            )}
        </DateContainerCard>
    );
}

const DateContainerCard = styled(LearnerCardBase)`
    padding: ${sizes.spacingMd};
    width: min(100%, 500px);
    height: fit-content;
    display: flex;
    justify-content: space-between;
    gap: ${sizes.spacingLg};
    @media (max-width: ${breakpoints.sm}) {
        gap: ${sizes.spacingMd};
    }
`;

const DateAndIconContainer = styled(FlexAlignCenter)`
    gap: ${sizes.spacingMd};
    @media (max-width: ${breakpoints.sm}) {
        gap: ${sizes.spacingSm};
    }
`;

const LargeDateText = styled(BodyLarge)`
    font-size: ${FONTSIZE.Headline4};
    overflow-wrap: unset;
    white-space: nowrap;
    word-break: keep-all;
    @media (max-width: ${breakpoints.sm}) {
        font-size: ${FONTSIZE.Headline5};
    }
`;
